import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=admin
  const [token, setToken] = useState(() => localStorage.getItem("cp3d_token"));

  const check = useCallback(async () => {
    const t = localStorage.getItem("cp3d_token");
    if (!t) {
      setUser(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setUser(data);
    } catch {
      localStorage.removeItem("cp3d_token");
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("cp3d_token", data.token);
    setToken(data.token);
    setUser({ email: data.email, name: data.name, role: "admin" });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("cp3d_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
